import { PaymentPlanModel } from '@frontend/api-payment-plans';
import { TableColumnConfig } from '@frontend/design-system';
import { formatCentsToCurrency } from '../../../utils/currency-helpers';
import { isoDateToDisplayLocalString } from '../../../utils/date-helpers';
import { PaymentPlanStatusChip } from '../../PaymentPlanStatusChip';
import { PaymentsListContactName } from '../../PaymentsContactName/payments-list-contact-name';

export const generateColumns: TableColumnConfig<PaymentPlanModel>[] = [
  {
    id: 'planName',
    Header: 'Plan Name',
    accessor: (paymentPlan) => paymentPlan.name,
    minWidth: 150,
    cellConfig: {
      showHoverLabel: true,
    },
  },
  {
    id: 'person',
    Header: 'Contact Name',
    accessor: (paymentPlan) => paymentPlan,
    minWidth: 150,
    cellRenderer: (paymentPlan: PaymentPlanModel) => (
      <PaymentsListContactName
        id={paymentPlan.person.id}
        name={`${paymentPlan.person.firstName} ${paymentPlan.person.lastName}`}
        locationId={paymentPlan.locationId}
      />
    ),
  },
  {
    id: 'balanceRemaining',
    Header: 'Remaining Balance',
    accessor: (paymentPlan) => formatCentsToCurrency(paymentPlan.paymentSummary?.remainingAmount ?? 0),
    minWidth: 150,
    disableResizing: true,
    cellAlign: 'right',
  },
  {
    id: 'paymentAmount',
    Header: 'Payment Amount',
    accessor: (paymentPlan) => formatCentsToCurrency(paymentPlan.schedule?.paymentAmount ?? 0),
    minWidth: 150,
    disableResizing: true,
    cellAlign: 'right',
  },
  {
    id: 'lastPaymentAt',
    Header: 'Last Paid Date',
    accessor: (paymentPlan) => isoDateToDisplayLocalString(paymentPlan?.schedule?.lastPaymentAt ?? ''),
    minWidth: 150,
    disableResizing: true,
    disableSortBy: true,
  },
  {
    id: 'nextPaymentAt',
    Header: 'Next Payment Due',
    accessor: (paymentPlan) => isoDateToDisplayLocalString(paymentPlan?.schedule?.nextPaymentAt ?? ''),
    minWidth: 150,
    disableResizing: true,
    disableSortBy: true,
  },
  {
    id: 'status',
    Header: 'Plan Status',
    accessor: (paymentPlan) => paymentPlan,
    cellRenderer: (paymentPlan: PaymentPlanModel) => (
      <PaymentPlanStatusChip paymentPlanStatus={paymentPlan?.status} statusReason={paymentPlan?.statusReason} />
    ),
    minWidth: 90,
    disableResizing: true,
    disableSortBy: true,
  },
];
